import { useState, useEffect } from 'react';
import { Dialog, Button, DayPicker } from '@workspace/design-system/src/components';

interface ApplyPlanDirectPaymentDialogProps {
    mode: 'apply' | 'extend';
    planName: string;
    channelName: string;
    isLoading?: boolean;
    onClose: () => void;
    onConfirm: (startDate: Date) => void;
}

export function ApplyPlanDirectPaymentDialog({
    mode,
    planName,
    channelName,
    isLoading = false,
    onClose,
    onConfirm,
}: ApplyPlanDirectPaymentDialogProps) {
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
    const [isLocked, setIsLocked] = useState(false);

    // isLoading이 해제되면 로컬 락도 해제
    useEffect(() => {
        if (!isLoading) {
            setIsLocked(false);
        }
    }, [isLoading]);

    const handleConfirm = () => {
        if (!selectedDate || isLoading || isLocked) return;
        setIsLocked(true);
        // 선택한 날짜를 UTC로 변환 (한국 시간으로 선택된 날짜를 UTC 시간으로 변환)
        // 한국 시간으로 2025년 12월 12일 00:00:00 → UTC로는 2025년 12월 11일 15:00:00

        onConfirm(selectedDate);
        // onClose()는 외부에서 제어하도록 제거
    };
    const isApplyMode = mode === 'apply';
    return (
        <Dialog>
            <Dialog.Content>
                <Dialog.Header
                    title={`${planName}를 ${isApplyMode ? '적용' : '연장'}하시겠어요?`}
                    type="question"
                    showIcon
                />

                <Dialog.Body>
                    <div className="flex flex-col gap-4">
                        <p className="text-sm text-[#101010] leading-5">
                            결제일 지정 후 진행시,<br />
                            {channelName} 채널에 {planName}가 {isApplyMode ? '즉시 적용됩니다.' : '연장됩니다.'}
                        </p>
                        <div className="w-full [&>*]:w-full">
                            <DayPicker value={selectedDate} onChange={setSelectedDate} hrizontalOptions="between" placeholder="결제일을 지정해 주세요." />
                        </div>
                    </div>
                </Dialog.Body>

                <Dialog.Footer>
                    <Button
                        styleType="basic"
                        styleSize="M-40"
                        onClick={() => {
                            if (isLoading || isLocked) return;
                            onClose();
                        }}
                        disabled={isLoading || isLocked}
                    >
                        닫기
                    </Button>
                    <Button
                        styleType="primary"
                        styleSize="M-40"
                        onClick={handleConfirm}
                        disabled={!selectedDate || isLoading || isLocked}
                        isLoading={isLoading}
                    >
                        요금제 {mode === 'apply' ? '적용' : '연장'}
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}
